import React from "react";
import ReactDom from "react-dom";

export default React.createClass({

    //@TODO set the column widths as default props that can be overridden using getDefaultProps()




    render: function(){

      var containerClass = "cs-wrapper";
      containerClass += " " + this.props.className;

        return(
            <div className={containerClass}>
              <div className="cs-loader">
                <div className="cs-loader-inner">
                  <label>●</label>
                  <label>●</label>
                  <label>●</label>
                  <label>●</label>
                  <label>●</label>
                  <label>●</label>
                </div>
              </div>
            </div>

        );
    }
});


// WEBPACK FOOTER //
// ./src/js/components/elements/spinner.jsx